export enum AssistantChatRole {
    User = "user",
    Assistant = "assistant",
}

export interface AssistantChatSourceModel {
    id: string;
    link: string;
    relevanceScore: number;
}

export interface AssistantChatMessageModel {
    id: string;
    role: AssistantChatRole;
    text: string;
    sources?: AssistantChatSourceModel[];
    createdAt: number;
}
